import React from 'react';

import { Bar, defaults } from 'react-chartjs-2';
import numeral from 'numeral';
import moment from 'moment';
import _ from 'lodash';

defaults.global.defaultFontStyle = 'bold';
defaults.global.defaultFontFamily = '"proxima-nova-soft", "Arial Rounded MT", "Arial", "sans-serif"';
defaults.global.defaultFontSize = 14;

const cf = num => numeral(num).format('0,0');

const MIN_XAXIS_DAYS = 20;

function getChartdataFromAnalytics(trackedAsset) {
  const latest = trackedAsset.statistics.slice(-100);
  const latestViews = latest.map(s => ({
    x: Date.parse(s.createdDate),
    y: s.viewCount,
  }));
  return latestViews;
}

const dyzioPalette = {
  pink: '#fc4085',
  bgPink: '#ffecf3',
  green: '#20c49e',
  bgGreen: '#d4faf1',
  amber: '#fdb02b',
  bgAmber: '#fff1d5',
  blue: '#9ad2ff',
  bgBlue: '#323299',
};


function getDailyViewingFromAnalytics(trackedAsset) {
  const latest = trackedAsset.statistics.slice(-100);
  const dailyViews = [];

  _.forEach(latest, (dp, idx) => {
    const lastPoint = latest[idx - 1];
    // only include the data point if it's a days difference.
    if (lastPoint) {
      const d1 = moment(dp.createdDate);
      const d0 = moment(lastPoint.createdDate);
      const hoursDelta = moment.duration(d1.diff(d0)).asHours();
      if (hoursDelta > 20 && hoursDelta < 30) {
        const delta = lastPoint ? dp.viewCount - lastPoint.viewCount : 0;
        dailyViews.push({
          x: Date.parse(dp.createdDate),
          y: delta,
        });
      }
    }
  });

  return dailyViews;
}

const getXAxisMin = trackedAsset => {
  const firstStat = trackedAsset.statistics[0];
  console.log(firstStat.createdDate);
  const d1 = moment.utc(firstStat.createdDate);
  console.log(`d1: ${d1}`);
  console.log(d1.format('YYYY-MM-DD'));
  const d2 = moment.utc();
  console.log(`d2: ${d2}`);
  console.log(d2);
  console.log(d2.format('YYYY-MM-DD'));

  let min = d2.subtract(MIN_XAXIS_DAYS, 'days');

  const daysDelta = moment.duration(d2.diff(d1)).asHours();
  console.log(`DD: ${daysDelta}`);
  if (daysDelta > MIN_XAXIS_DAYS) {
    console.log('blah');
    min = d1;
  }

  return min;
};

const AnalyticsChart = ({ trackedAsset }) => {
  if (!trackedAsset || !trackedAsset.statistics) return null;
  const analyticsData = getChartdataFromAnalytics(trackedAsset);
  const data = {
    datasets: [{
      fill: false,
      type: 'line',
      fillColor: 'rgba(38,228,184,0.05)',
      backgroundColor: 'rgba(38,228,184,0.05)',
      borderColor: 'rgba(38,228,184,1)',
      pointBorderColor: 'rgba(38,228,184,1)',
      pointBackgroundColor: '#fff',
      pointHoverBackgroundColor: 'rgba(38,228,184,1)',
      pointHoverBorderColor: 'rgba(38,228,184,1)',
      label: 'Total Views (left axis)',
      data: analyticsData,
      yAxisID: 'y-axis-1',
    },
    {
      type: 'bar',
      label: 'Daily Views (right axis)',
      fillColor: dyzioPalette.bgPink,
      backgroundColor: dyzioPalette.bgPink,
      borderColor: dyzioPalette.pink,
      data: getDailyViewingFromAnalytics(trackedAsset),
      borderWidth: 1,
      yAxisID: 'y-axis-2',
    },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    tooltips: {
      mode: 'index',
      intersect: false,
      callbacks: {
        title: tooltipItems => (`${moment(tooltipItems[0].xLabel).format('ddd DD MMM hh:mm')}`),
        label: tooltipItem => {
          const desc = tooltipItem.datasetIndex === 0 ? 'Total Views' : 'Daily Views';
          return `${cf(tooltipItem.yLabel)} ${desc}`;
        },
      },
    },
    title: {
      display: false,
      text: 'Total Viewing',
      padding: 10,
      fontSize: 18,
    },
    legend: {
      display: true,
    },
    elements: {
      line: {
        tension: 0,
      },
    },
    layout: {
      padding: 20,
      fullWidth: false,
    },
    hover: {
      mode: 'nearest',
      intersect: true,
    },
    scales: {
      xAxes: [
        {
          type: 'time',
          ticks: {
            maxRotation: 0,
            autoSkip: true,
            maxTicksLimit: 5,
            // callback: function(value) {
            //     return (new Date(value).getDate() % 5 == 0) ? value : null;
            // },
          },
          time: {
            displayFormats: {
              day: 'ddd DD MMM',
            },
            min: getXAxisMin(trackedAsset),
            max: moment().add(1, 'days'),
          },
        },
      ],
      yAxes: [{
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'left',
        title: {
          text: 'Total Viewing',
        },
        id: 'y-axis-1',
      }, {
        type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
        display: true,
        position: 'right',

        id: 'y-axis-2',
        // grid line settings
        gridLines: {
          drawOnChartArea: false, // only want the grid lines for one axis to show up
        },
      }],
    },
  };

  // scales: {
  //   yAxes: [{
  //     type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
  //     display: true,
  //     position: 'left',
  //     id: 'y-axis-1',
  //   }, {
  //     type: 'linear', // only linear but allow scale type registration. This allows extensions to exist solely for log scale for instance
  //     display: true,
  //     position: 'right',
  //     id: 'y-axis-2',
  //     // grid line settings
  //     gridLines: {
  //       drawOnChartArea: false, // only want the grid lines for one axis to show up
  //     },
  //   }],
  // }

  return (
    <Bar data={data} options={chartOptions} />
  );
};

export default AnalyticsChart;



// WEBPACK FOOTER //
// ./src/components/chart/index.js